export const version: { buildNumber: number } = {
  buildNumber: 51,
};
